var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternal = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.081 4h-5.057a.734.734 0 1 0 0 1.468h3.367l-7.205 7.205a.734.734 0 1 0 1.038 1.038l7.123-7.123V9.79a.734.734 0 1 0 1.468 0V4.734A.734.734 0 0 0 19.081 4Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.541 11.394a.734.734 0 0 0-.734.734v5.792c0 .265-.224.49-.49.49h-9.36a.496.496 0 0 1-.489-.49V8.56c0-.266.224-.49.49-.49h5.812a.734.734 0 1 0 0-1.468H5.958A1.96 1.96 0 0 0 4 8.56v9.36a1.96 1.96 0 0 0 1.958 1.958h9.36a1.96 1.96 0 0 0 1.958-1.958v-5.792a.734.734 0 0 0-.734-.734Z",
  fill: "currentColor"
})));
export default SvgExternal;